var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Dialog', {
    attrs: {
      "title": "Organization Members",
      "show": _vm.isOpen,
      "onClose": _vm.onCancel
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('Table', {
    attrs: {
      "items": _vm.members,
      "columns": _vm.columns,
      "loading": _vm.loading,
      "links": _vm.links,
      "actions": _vm.actions
    }
  })], 1), _c('el-divider'), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("OK")])], 1)], 1), _vm.showEditDialog ? _c('EditDialog', {
    attrs: {
      "item": _vm.editItem,
      "isOpen": _vm.showEditDialog,
      "onCancel": _vm.onCancelEditMember,
      "onSave": _vm.onSaveEditMember
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }